var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Poptip',{attrs:{"transfer":"","confirm":"","title":_vm.popTitle,"disabled":_vm.loading,"placement":"top-end"},on:{"on-ok":_vm.onOk}},[_c('Icon',_vm._b({staticStyle:{"cursor":"pointer","vertical-align":"baseline"}},'Icon',_vm.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }